import React__default from 'react';
import Typography from '../Typography/Typography.js';

var CHARACTER_LIMIT_THRESHOLD = 0.8;
var renderCharacterLimitEndAdornment = function renderCharacterLimitEndAdornment(params) {
  var characterLimit = params.characterLimit,
    className = params.className,
    value = params.value,
    variant = params.variant;
  if (typeof value !== 'string' || !value.length) {
    return null;
  }
  var showCharacterLimit = value.length >= characterLimit * CHARACTER_LIMIT_THRESHOLD;
  if (!showCharacterLimit) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Typography, {
    className: className,
    color: "text-text-placeholder",
    variant: variant
  }, characterLimit - value.length);
};

export { renderCharacterLimitEndAdornment };
//# sourceMappingURL=renderers.js.map
